export type Market = 'pl' | 'cz' | 'de'

export const API: Record<Market, string> = {
  pl: process.env.NEXT_PUBLIC_API_URL || '',
  cz: process.env.NEXT_PUBLIC_CZ_API_URL || '',
  de: process.env.NEXT_PUBLIC_DE_API_URL || '',
}

export const API_PROXY: Record<Market, string> = {
  pl: process.env.NEXT_PUBLIC_API_URL_PROXY || '',
  cz: process.env.NEXT_PUBLIC_CZ_API_URL_PROXY || '',
  de: process.env.NEXT_PUBLIC_DE_API_URL_PROXY || '',
}
